import React from 'react'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {DesktopHeader} from 'components/DesktopHeader'
import {PreferencesWidgetWithStore} from 'components/PreferencesWidgetWithStore'
import {useInAppFirst} from 'hooks/useInAppFirst'
import {useShowPreferencesOverlay} from 'hooks/useShowPreferencesOverlay/useShowPreferencesOverlay'
import {getVclidCookie} from 'modules/cookies/selectors'
import {getIsSyntheticTest} from 'modules/meta/selectors'

import {useDeviceLayout} from '@vio/atlas/context/deviceLayout'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {useBrandCapabilities} from '@vio/core/src/_web/brand/hooks/useBrandCapabilities'
import {useIsEmbeddedWithBrand} from '@vio/core/src/_web/brand/hooks/useIsEmbeddedWithBrand'
import {useIsHydrated} from '@vio/core/src/utils/react/hooks/useIsHydrated'
import {CustomHeader} from '@vio/shared/src/whiteLabel/CustomHeader'

import {BaseHomeDesktopHeader} from './BaseHomeDesktopHeader'
import {BaseHomeMobileHeader} from './BaseHomeMobileHeader'
import {FixedHeader} from './FixedHeader'

const HeaderWrapper = styled.div`
  position: relative;
  z-index: 4;
`

interface Props {
  isStickyHeaderVisible?: boolean
}
export const Header: React.FC<Props> = ({isStickyHeaderVisible}) => {
  const {isMobile} = useDeviceLayout()
  const isSyntheticTest = useSelector(getIsSyntheticTest)
  const vioClickId = useSelector(getVclidCookie)
  const isHydrated = useIsHydrated()
  const {brandCode} = useBrand()
  const {shell} = useBrandCapabilities()
  const isEmbedded = useIsEmbeddedWithBrand()
  const {isInAppFirst} = useInAppFirst()
  const handleShowPreferences = useShowPreferencesOverlay()

  if (isEmbedded || isInAppFirst) {
    return null
  }

  if (shell.hasCustomHeader) {
    return (
      <HeaderWrapper>
        <CustomHeader
          brandCode={brandCode}
          isFloating={!isMobile}
          isHomePage
          currencySelector={<PreferencesWidgetWithStore />}
          onShowPreferences={handleShowPreferences}
          vioClickId={vioClickId}
        />
      </HeaderWrapper>
    )
  }

  if (!isMobile && shell.hasAlternativeSearchForm.enabled)
    return (
      <HeaderWrapper>
        <DesktopHeader isFixed />
      </HeaderWrapper>
    )

  return (
    <>
      {isMobile ? (
        <BaseHomeMobileHeader />
      ) : (
        <HeaderWrapper>
          <BaseHomeDesktopHeader
            showSupportButton={shell.hasHomeDesktopSupportButton}
          />
        </HeaderWrapper>
      )}
      {isHydrated && shell.hasHomeStickyHeader && !isSyntheticTest && (
        <FixedHeader isVisible={isStickyHeaderVisible} />
      )}
    </>
  )
}
